// 横向排序柱状图
import { Axis, Tooltip, Grid, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption7 = {
  styleId:7,
  pluginName: ["chartOption3AxisLenControlPlugin", "formaterStringToFuncPlugin"],
  // 是否显示柱图折线转化
  isBarToLine: false,
  refreshTime: 90000, //间隔刷新时间
  formatterEv: true, //判断当前图表组件内是否有函数需要用eval执行
  tooltip: new Tooltip("axis", {
    extraCssText: "border-radius: 10px;",
    show: true,
    trigger: "axis",
    axisPointer: { type: "shadow" },
    borderWidth: 0,
    textStyle: { fontSize: 14, fontWeight: "400", color: "rgba(255, 255, 255, 0.8)" },
    backgroundColor: "rgba(0,0,0,1)",
    showContent: true
  }),
  grid: new Grid(50, 19, 15, 10, {
    edgeType: "single",
    bottom: 8
  }),
  legend: new Legend({
    top: "top",
    left: "left",
    show: false,
    data: ["数据1"],
    textStyle: { fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
  }),
  yAxis: new Axis("category", {
    inverse: true,
    nameLocation: "start",
    axisLabel: {
      padding: [0, 0, 0, 0],
      verticalAlign: "bottom",
      rich: {
        rank: {
          width: 25,
          height: 25,
          align: "center",
          // backgroundColor: "rgba(252, 73, 28, 1)",
          backgroundColor: {
            type: "linear",
            x: 0.5, //左
            y: 0.8, //上
            x2: 0, //右
            y2: 0, //下
            colorStops: [
              {
                offset: 0,
                color: "rgba(28, 78, 210, 1)" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(0, 137, 255, 1)" // 100% 处的颜色
              }
            ],
            global: false // 缺省为 false
          },
          borderRadius: 0,

          fontSize: 16,
          fontFamily: "D-din",
          color: "rgba(255, 255, 255, 1)",
          fontWeight: "400",
          rotate: 0
        },
        title: {
          align: "left",
          //height:10,
          width: 30,
          height: 0,
          padding: [0, 0, -20, 100],

          fontSize: 16,
          color: "rgba(0, 0, 0, 0.84)",
          fontWeight: "400",
          rotate: 0
        }
      },
      margin: -50,
      formatterEv: "custom",
      formatter: { _custom: { type: "function", display: "<span>ƒ</span> (value, index)" } }
    },
    data: [
      {
        value: "湖北文化馆晚会直播活动",
        textStyle: { verticalAlign: "middle", padding: [0, 150, 25, 0], align: "center" }
      },
      {
        value: "黄冈文化馆广场舞直播",
        textStyle: { verticalAlign: "middle", padding: [0, 150, 25, 0], align: "center" }
      },
      { value: "我要上村晚筛选", textStyle: { verticalAlign: "middle", padding: [0, 150, 25, 0], align: "center" } },
      {
        value: "乡村达人秀节目直播",
        textStyle: { verticalAlign: "middle", padding: [0, 150, 25, 0], align: "center" }
      },
      {
        value: "黄冈文化馆广场舞直播二",
        textStyle: { verticalAlign: "middle", padding: [0, 150, 25, 0], align: "center" }
      }
    ],
    splitLine: {
      lineStyle: {
        color: "rgba(0, 0, 0, 0.24)",
        type: "solid"
      }
    }
  }),
  xAxis: new Axis("value", {
    show: false
  }),
  animationEasing: "bounceOut",
  animationDuration: 1000,
  animationEasingUpdate: "bounceOut",
  animationDurationUpdate: 1000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "rectangular" //直角坐标系
  },
  series: [
    {
      label: {
        formatter: "{c}{valueUnit|}",
        position: [400, -20],
        show: true,
        rich: {
          valueUnit: { fontSize: 14, fontWeight: "400", color: "rgba(0, 0, 0, 0.8)" }
        },
        fontSize: 16,
        fontWeight: "400",
        fontFamily: "D-din",

        color: "rgba(0, 137, 255, 1)",
        rotate: 0
      },
      name: "数据1",
      showBackground: true,
      backgroundStyle: { color: "#E0E0E0", borderRadius: 10 },
      barWidth: 10,
      type: "bar",
      colorBy: "series",
      itemStyle: {
        borderRadius: 10,
        color: {
          colorStops: [
            { offset: 0, color: "rgba(90,129,255,1)" },
            { offset: 1, color: "rgba(75,223,255,1)" }
          ],
          x: 0,
          y: 0,
          y2: 0,
          x2: 1,
          type: "linear"
        }
      },
      // 需要排序的数据 提前把数据排好，解决颜色设置对不上的问题
      data: [
        {
          value: 390,
          itemStyle: {
            color: {
              colorStops: [
                { offset: 0, color: "rgba(101, 30, 168, 1)" },
                { offset: 1, color: "rgba(227, 34, 115, 1)" }
              ],
              x: 0,
              y: 0,
              y2: 0,
              x2: 1,
              type: "linear"
            }
          }
        },
        {
          value: 334,
          itemStyle: {
            color: {
              colorStops: [
                { offset: 0, color: "rgba(254, 136, 88, 1)" },
                { offset: 1, color: "rgba(250, 209, 38, 1)" }
              ],
              x: 0,
              y: 0,
              y2: 0,
              x2: 1,
              type: "linear"
            }
          }
        },
        {
          value: 200,
          itemStyle: {
            color: {
              colorStops: [
                { offset: 0, color: "rgba(1, 137, 171, 1)" },
                { offset: 1, color: "rgba(94, 255, 183, 1)" }
              ],
              x: 0,
              y: 0,
              y2: 0,
              x2: 1,
              type: "linear"
            }
          }
        },
        {
          value: 101,
          itemStyle: {
            color: {
              colorStops: [
                { offset: 0, color: "rgba(0, 71, 255, 1)" },
                { offset: 1, color: "rgba(3, 130, 235, 1)" }
              ],
              x: 0,
              y: 0,
              y2: 0,
              x2: 1,
              type: "linear"
            }
          }
        },
        {
          value: 52,
          itemStyle: {
            color: {
              colorStops: [
                { offset: 0, color: "rgba(0, 71, 255, 1)" },
                { offset: 1, color: "rgba(3, 130, 235, 1)" }
              ],
              x: 0,
              y: 0,
              y2: 0,
              x2: 1,
              type: "linear"
            }
          }
        }
      ],
      realtimeSort: true,
      animationDelay: { _custom: { type: "function", display: "<span>ƒ</span> (t)" } }
    }
  ],
  dataZoomSet: {
    dataLengthAuto: "all"
  }
}
